/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Password_Label_UppercaseInputs */

const nl_validation_password_label_uppercase = /** @type {(inputs: Validation_Password_Label_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een hoofdletter`)
};

/**

* @param {Validation_Password_Label_UppercaseInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const validation_password_label_uppercase = /** @type {((inputs?: Validation_Password_Label_UppercaseInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Password_Label_UppercaseInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_validation_password_label_uppercase(inputs)
});
export { validation_password_label_uppercase as "validation.password.label_uppercase" }